import React from "react"
import { useDispatch } from "react-redux"
import CustomImage from "@/main/customImage"

import {
    toggleRequestViewingModal,
    setRequestViewingProperty,
} from "@/slices/requestViewingModalSlice"

import { Container, Row, Col, Button } from "react-bootstrap"

function HeroImage({ property }) {
    const dispatch = useDispatch()
    const formatter = new Intl.NumberFormat("en", {
        style: "currency",
        currency: "GBP",
        minimumFractionDigits: 0,
    })

    return (
        <section>
            {/* Hero Image */}
            <Container fluid className="p-0 overflow-hidden">
                <Row className="m-0 gx-0 position-relative overflow-hidden">
                    {/* Parallax Image */}

                    <CustomImage
                        src={
                            property.images[0]?.imgix_url ||
                            "https://webb-jenkins-static-164679926.imgix.net/placeholder.svg"
                        }
                        alt={`Property ${property.property_ref} main`}
                        layout="fill"
                        objectFit="cover"
                        objectPosition="center"
                        sizes="100vw"
                        priority
                        className="z-index-minus-1"
                    />
                    <section className="parallax overflow-hidden p-0">
                        {/* Main Overlay */}
                        <div className="wjoverlay">
                            <Container fluid="md">
                                <Row className="gx-0 align-items-center justify-content-center parallax-content">
                                    <Col xs={12} xxl={10}>
                                        <h1 className="text-white text-center px-2 px-lg-0 title-disappear d-flex justify-content-center">
                                            {property.display_address}
                                        </h1>

                                        <div className="price-disappear">
                                            <span className="h3 d-flex text-white text-center mb-3 price-disappear justify-content-center">
                                                {property.trans_type_id === 2 &&
                                                property
                                                    .residential_lettings_details
                                                    ?.let_rent_frequency === 0
                                                    ? "Weekly Rental of "
                                                    : property
                                                            .residential_lettings_details
                                                            ?.let_rent_frequency ===
                                                        1
                                                      ? "Monthly Rental of "
                                                      : property
                                                              .residential_lettings_details
                                                              ?.let_rent_frequency ===
                                                          2
                                                        ? "Quarterly Rental of "
                                                        : property
                                                                .residential_lettings_details
                                                                ?.let_rent_frequency ===
                                                            3
                                                          ? "Yearly Rental of "
                                                          : ""}
                                                {formatter.format(
                                                    property.price,
                                                )}
                                            </span>
                                        </div>

                                        <div className="d-flex no-pad-landscape justify-content-center">
                                            <div className="icon-disappear">
                                                <span className="me-1 align-text-top">
                                                    <CustomImage
                                                        src={
                                                            "https://webb-jenkins-static-164679926.imgix.net/icons/hero-bed.svg"
                                                        }
                                                        alt="Bed icon"
                                                        height={16}
                                                        width={24}
                                                    />
                                                </span>

                                                <span className="h6 text-white">
                                                    {property.bedrooms + " "}
                                                    Bedroom
                                                </span>
                                            </div>

                                            {property.bathrooms > 0 && (
                                                <div className="icon-disappear">
                                                    <span className="ms-5 me-1 align-text-center">
                                                        <CustomImage
                                                            src={
                                                                "https://webb-jenkins-static-164679926.imgix.net/icons/hero-bath.svg"
                                                            }
                                                            alt="Bath icon"
                                                            height={16}
                                                            width={16}
                                                        />
                                                    </span>

                                                    <span className="h6 text-white no-gutter">
                                                        {property.bathrooms +
                                                            " "}
                                                        Bathroom
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                        <div className="d-flex justify-content-center">
                                            <Button
                                                variant="outline-warning"
                                                size="lg"
                                                className="btn-disappear mt-4 shadow-0 rounded-0 z-index-1"
                                                onClick={() => {
                                                    dispatch(
                                                        toggleRequestViewingModal(
                                                            true,
                                                        ),
                                                    )
                                                    dispatch(
                                                        setRequestViewingProperty(
                                                            property,
                                                        ),
                                                    )
                                                }}
                                                style={{
                                                    background: "white",
                                                }}
                                            >
                                                <span className="text-warning">
                                                    Request a viewing
                                                </span>
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                        {/* Main Overlay End */}
                    </section>

                    {/* Parallax Image End */}
                </Row>
            </Container>
            {/* Hero Image End */}
        </section>
    )
}

export default HeroImage
